module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-4.25f07dc1.png";